module.exports = __webpack_public_path__ + "static/media/new-harmonica-co-funded-by-the-eu.a99d948f.jpg";